import { COMPANY, CONTACT, DEAL, TICKET } from './ObjectTypes';
export default {
  [CONTACT]: 'contactIds',
  [COMPANY]: 'companyIds',
  [DEAL]: 'dealIds',
  [TICKET]: 'ticketIds'
};